import { Modal } from "@minervaproject/fds";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { fetchActiveCookies } from "../api";
import { useScript } from "../hooks";
import { LoginStore } from "../store/login";

const CookieModal = () => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();

  const [activeCookies, setActiveCookies] = useState([]);

  const [cookieScriptLoaded, cookieScriptError] = useScript(
    "https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.0.3/cookieconsent.min.js",
    {
      integrity: "sha384-PDjg2ZdS3khPzd53i18+7tzB32JVQfFMrTXYo21RqPgUmEVAPwIhxOUF/8sP79CS",
      crossOrigin: "anonymous",
    },
  );

  useEffect(() => {
    async function fetchCookies() {
      const cookies = await fetchActiveCookies();
      setActiveCookies(cookies);
    }
    fetchCookies();
  }, []);

  useEffect(() => {
    if (cookieScriptLoaded && !cookieScriptError) {
      window.cookieconsent?.initialise({
        palette: {
          popup: {
            background: "#f4f4f4",
            text: "#222222",
          },
          button: {
            background: "transparent",
            text: "#0A78BF",
            border: "#0A78BF",
          },
        },
        content: {
          message: "Minerva uses cookies necessary for features on the platform.",
          dismiss: "OK",
          link: "Cookie policy",
          href: "#",
        },
        onPopupOpen() {
          dispatch(LoginStore.actions.update({ cookieBannerIsShowing: true }));
          document.querySelector(".cc-link").addEventListener("click", (e) => {
            e.preventDefault();
            setShowModal(true);
            document.querySelector(".cc-dismiss").click();
          });

          // dismiss banner
          document.querySelector(".cc-dismiss").addEventListener("click", (e) => {
            e.preventDefault();
            dispatch(LoginStore.actions.update({ cookieBannerIsShowing: false }));
          });
        },
      });
    }
  }, [cookieScriptLoaded, cookieScriptError, dispatch]);

  if (!showModal) return null;

  return (
    <Modal
      onClose={(showModalValue) => setShowModal(showModalValue)}
      title="Cookie Declaration"
      width="80vw"
    >
      <main className="modal__content">
        <p>
          Cookies are small text files that can be used by websites to make a user&apos;s experience
          more efficient.
        </p>
        <p>
          The law states that we can store cookies on your device if they are strictly necessary for
          the operation of this site. This site uses cookies that provide necessary functionality,
          features, and third-party services such as Google OAuth. Some cookies are placed by third
          party services that appear on our pages. Cookies make a website usable by enabling basic
          functions like page navigation and access to secure areas of the website. The website
          cannot function properly without these cookies.
        </p>
        <div className="cookie-table table-wrapper">
          <table>
            <tbody>
              <tr>
                <th>Name</th>
                <th>Provider</th>
                <th>Purpose</th>
                <th>Expiry</th>
                <th>Type</th>
              </tr>
              {activeCookies.map((cookie) => {
                return (
                  <tr key={cookie.Name}>
                    <td>{cookie.Name}</td>
                    <td>{cookie.Provider}</td>
                    <td>{cookie.PurposeDescription}</td>
                    <td>{cookie.ExpireDescription}</td>
                    <td>{cookie.TrackerTypeName}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </main>
      <footer className="modal__footer">
        <button
          onClick={() => setShowModal(false)}
          className="modal__btn button-primary"
          aria-label="OK"
          type="submit"
        >
          OK
        </button>
      </footer>
    </Modal>
  );
};

export { CookieModal };
